const attendanceNotes = {
  'attendanceNotes.notes': 'Notas',
  'attendanceNotes.notesPlaceholder': 'Insira aqui suas anotações',
  'attendanceNotes.footer': 'Conteúdo salvo no encerramento da chamada.',
};

export default attendanceNotes;
